// extracted by mini-css-extract-plugin
module.exports = {"editor":"CommonStyle_editor","editorContainer":"CommonStyle_editorContainer","notification":"CommonStyle_notification"};